












































import {
  ref,
  defineComponent,
  reactive,
  getCurrentInstance,
  onMounted,
  computed,
  watch,
  nextTick,
} from '@vue/composition-api/dist/vue-composition-api';
import { SubmitContext } from 'tdesign-vue';
import i18n, { i18n_t } from '@/locales/i18n';
import tips, { MsgError } from '@/renderer/scripts/utils/tips';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
import {
  businessOptions2,
  scaleOptions2,
} from '@/renderer/views/desktop/FileManagement/Workbench/components/composition/surveyHandler';
import smh from '@/renderer/scripts/smh';
import { CreateOrgInfo } from '@/renderer/scripts/libs/smh-sdk-class/typings';
type UserRole = {
  value: string;
  icon: string;
};
type Step2FormData = {
  role: string;
  scale: string;
  business: string;
};
export default defineComponent({
  name: 'StepForm2',
  setup(props, context) {
    const industryList = reactive(businessOptions2);
    const vm = getCurrentInstance()?.proxy || context.root;
    // 默认的formData数据
    const tmpRoleName = ref('');
    const isFocus = ref(false);
    const formData = reactive<Step2FormData>({
      role: '',
      scale: '',
      business: '',
    });
    const historyData = reactive<Step2FormData>({
      role: '',
      scale: '',
      business: '',
    });
    const fixedRoles = [
      i18n_t('创始人'),
      i18n_t('商务负责人'),
      i18n_t('研发负责人'),
      i18n_t('采购负责人'),
      i18n_t('管理者'),
      i18n_t('员工'),
    ];
    const roles: UserRole[] = reactive([
      {
        value: i18n_t('创始人'),
        icon: 'creator',
      },
      {
        value: i18n_t('商务负责人'),
        icon: 'business',
      },
      {
        value: i18n_t('研发负责人'),
        icon: 'developer',
      },
      {
        value: i18n_t('采购负责人'),
        icon: 'pucharse',
      },
      {
        value: i18n_t('管理者'),
        icon: 'leader',
      },
      {
        value: i18n_t('员工'),
        icon: 'person',
      },
      {
        value: i18n_t('其他'),
        icon: 'other',
      },
    ]);
    const isOtherRole = computed(() => !fixedRoles.includes(formData.role));
    watch(
      () => formData.role,
      () => {
        if (isOtherRole.value) {
          // 选择了“其他”
          nextTick(() => {
            if (vm.$refs.industryInput) {
              const el = (vm.$refs.industryInput as HTMLElement[])[0];
              if (el) {
                el.focus();
                isFocus.value = true;
              }
            }
          });
        }
      },
    );
    const methods = {
      // tmpRoleName.value 输入框的值
      // role.value 选项的值
      // formData.role 表单真正的值
      // trimedValue 输入框的处理过的值
      handleBlur(role: UserRole) {
        isFocus.value = false;
        const limit = 6;
        let trimedValue = tmpRoleName.value.trim();
        const trimed = tmpRoleName.value !== trimedValue;
        if (trimedValue.length > limit) {
          // 超长，自动裁剪
          tips.warning(
            i18n_t('角色名字超出长度限制（{limit}字）', {
              limit,
            }),
          );
          trimedValue = trimedValue.substring(0, limit);
        }
        if (trimedValue.length === 0) {
          // 输入了空值
          if (trimed) {
            // 输多了空格，回滚成role.value
            tmpRoleName.value = role.value;
          } else {
            // 用户主动删除
            role.value = i18n_t('其他');
            tmpRoleName.value = '';
            formData.role = i18n_t('其他');
          }
        } else if (fixedRoles.includes(trimedValue)) {
          // 输入了已存在的固定值，这个选项要恢复成其他
          role.value = i18n_t('其他');
          tmpRoleName.value = '';
          formData.role = trimedValue;
        } else {
          // 有效的值，进行赋值
          tmpRoleName.value = trimedValue;
          role.value = trimedValue;
        }
      },
      createIndustry(value: any) {
        const oldIndustry = formData.business;
        const limit = 20;
        const realVal = value.trim();
        if (realVal.length > limit) {
          tips.warning(
            i18n_t('行业名称超出长度限制（{limit}字）', {
              limit,
            }),
          );
          return;
        }
        nextTick(() => {
          if (realVal) {
            industryList.push({
              value: realVal,
              label: realVal,
            });
            formData.business = realVal;
          } else {
            formData.business = oldIndustry;
          }
        });
      },
      // 数据查询+表单数据回显
      async showInfo() {
        try {
          const { data } = await smh.userAPI.getSurvey({
            type: 'create-org-info',
          });
          if (Array.isArray(data) && data.length === 1) {
            formData.role = data[0].data?.role || '';
            formData.scale = data[0].data?.scale || '';
            formData.business = data[0].data?.business;
            Object.assign(historyData, formData);
          }
        } catch (e) {
          tips.error(e as MsgError);
        }
      },
      async teamCreate(obj: CreateOrgInfo) {
        const { role, scale, business } = obj;
        try {
          await smh.userAPI.createSurvey({
            type: 'create-org-info',
            data: {
              scale,
              business,
              role,
            },
          });
        } catch (e) {
          tips.error(e as MsgError);
        }
      },
      sub() {
        const form = vm.$refs.form as any;
        form.submit();
      },
      submit({ validateResult, firstError }: SubmitContext<FormData>) {
        if (validateResult !== true) {
          tips.warning(firstError as string);
          return;
        }
        this.confirm();
      },
      async confirm() {
        if (formData) {
          try {
            await methods.teamCreate(formData);
            tips.success(i18n_t('修改成功'));
            formData.role &&
              historyData.role !== formData.role &&
              reporter.report('manager_new_guide_success', {
                success_count_type: 'step_two_information_role',
              });
            formData.business &&
              historyData.business !== formData.business &&
              reporter.report('manager_new_guide_success', {
                success_count_type: 'step_two_information_industry',
              });
            formData.scale &&
              historyData.scale !== formData.scale &&
              reporter.report('manager_new_guide_success', {
                success_count_type: 'step_two_information_scale',
              });
            Object.assign(historyData, formData);
          } catch (e) {
            tips.error(e as MsgError);
          }
        }
      },
    };
    onMounted(() => {
      methods.showInfo();
    });
    return {
      isFocus,
      tmpRoleName,
      isOtherRole,
      fixedRoles,
      roles,
      formData,
      scaleOptions2,
      industryList,
      ConstantConfig,
      ...methods,
    };
  },
});
